import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { U2bAdminApi } from '@modules/admin/_api/u2b-admin.api';

export interface AdminBcmPermissionDescriptionDto {
    permissionId: number;
    permissionName: string;
    permissionDescription: string | null;
}

export class U2bAdminBcmPermissionsApi extends U2bAdminApi {

    protected className = 'U2bAdminBcmPermissionsApi';

    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    updatePermissionDescription(
        permissionId: number,
        permissionDescription: string | null,
    ): Observable<AdminBcmPermissionDescriptionDto> {
        return super.patch<AdminBcmPermissionDescriptionDto>(
            `bcm-permissions/${permissionId}`,
            { permissionDescription },
        );
    }
}
